import { CircularProgress } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl, FramerTooltip } from "@ryde/controls";
import { ICourseDto, useIsMobile } from "@ryde/shared";

import { ButtonHeader } from "../../../right";
import { useCourseMeasuredTimes } from "./use-course-measured-times";

/** Matches the 20px `ButtonHeader` sizes its icons to, so the swap does not resize the header. */
const MEASURED_TIMES_SPINNER_SIZE = 20;

interface ICourseMeasuredTimesButtonProps {
  courseDto: Partial<ICourseDto> | undefined;
}

export const CourseMeasuredTimesButton: FC<ICourseMeasuredTimesButtonProps> = ({
  courseDto,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const { isLoading, openMeasuredTimes } = useCourseMeasuredTimes(courseDto);

  const handleButtonClick = useEvent(() => {
    void openMeasuredTimes();
  });

  return (
    <AccessControl entity="course" action="update">
      <FramerTooltip content={t("stationTiming.MEASURED_TIMES_TOOLTIP")}>
        <ButtonHeader
          onClick={handleButtonClick}
          disabled={isLoading}
          aria-label={t("stationTiming.MEASURED_TIMES")}
          aria-busy={isLoading}
        >
          {isLoading ? (
            <CircularProgress
              size={MEASURED_TIMES_SPINNER_SIZE}
              data-e2e="course-measured-times-spinner"
            />
          ) : (
            <SVG_MUI.ChartBarSVG data-e2e="course-measured-times-svg" />
          )}
          {!isMobile && <span>{t("stationTiming.MEASURED_TIMES")}</span>}
        </ButtonHeader>
      </FramerTooltip>
    </AccessControl>
  );
};
